import React from 'react';
import { Form,  Radio} from 'semantic-ui-react';


class VerificationFormField extends React.Component {

  handleChange(selected, event, target){
    this.props.onChange(event, Object.assign(target, {value: selected}))
  }
  render = () => {
    const {
      value,
      onChange,
      children,
      ...rest
    } = this.props;
    return (
      <Form.Group>
        {children}
        <Form.Field inline>
          <Radio
            label="yes"
            checked={value === true}
            onChange={this.handleChange.bind(this, true)}
            onBlur={this.props.onBlur}
            {...rest}
          />
        </Form.Field>
        <Form.Field inline>
          <Radio
            label="no"
            checked={value === false}
            onChange={this.handleChange.bind(this, false)}
            onBlur={this.props.onBlur}
            {...rest}
          />
        </Form.Field>
      </Form.Group>
    )
  }
}



export default VerificationFormField;



// WEBPACK FOOTER //
// ./src/component/VerificationFormField.js